import { render, staticRenderFns } from "./GenelIstatistikHitam.vue?vue&type=template&id=28c3ecd6&scoped=true"
import script from "./GenelIstatistikHitam.vue?vue&type=script&lang=ts"
export * from "./GenelIstatistikHitam.vue?vue&type=script&lang=ts"
import style0 from "./GenelIstatistikHitam.vue?vue&type=style&index=0&id=28c3ecd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3ecd6",
  null
  
)

export default component.exports